import React from 'react';
import PropTypes from 'prop-types';

const SiteSearchResult = (props) => {
  return (
    <div className="site-search__result">
      <div
        className={`site-search__result__icon site-search__result__icon--${props.type}`}
      >
        <div className="visually-hidden">{props.type}</div>
      </div>
      <div className="site-search__result__text-content">
        <h3 className="site-search__result__title">
          <a href={props.url}>{props.title}</a>
        </h3>
        <div className="site-search__result__description">
          {props.description}
        </div>
      </div>
    </div>
  );
};

SiteSearchResult.propTypes = {
  title: PropTypes.array,
  url: PropTypes.array,
  description: PropTypes.array,
  type: PropTypes.array,
};

export default SiteSearchResult;
